module.exports = __webpack_public_path__ + "static/benchmark-50c65c9ae4656fae611ac73350ba9d64.png";